import { isString } from "lodash-es";
export function format(value, ...args) {
    return (designSystem) => {
        return args.reduce((reducedValue, currentValue, index) => {
            return reducedValue.replace(new RegExp(`\\{${index}\\}`, "g"), currentValue(designSystem));
        }, value);
    };
}
export function toString(resolver) {
    return (designSystem) => String(resolver(designSystem));
}
export function important(value) {
    return isString(value)
        ? `${value} !important`
        : (arg) => important(value(arg));
}
